import { render, staticRenderFns } from "./InvitePopup.vue?vue&type=template&id=70a2a734&"
import script from "./InvitePopup.vue?vue&type=script&lang=js&"
export * from "./InvitePopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports